const version = require('../package.json').version;
const utils = require('./utils');
const abi = require('./abi');

const Contract = require("./contract");
const HttpRequest = require("./httprequest");
const Accounts = require("./accounts");
class Mcp {
    /**
     * Init MCP
     * @param {object | string} request Node configuration
     * @param {boolean} request.dev Environment configuration
     * @param {string} request.host Host address
     * @param {string} request.port Host port
     * @param {object} request.ssl https config
     * @param {boolean} request.ssl.enable open ssl
     */
    constructor(request) {
        if (request) {
            if (Object.prototype.toString.call(request) === '[object String]') {
                const urlData = new URL(request);
                this.host = urlData.hostname;
                this.port = Number(urlData.port);
                this.ssl = urlData.protocol === 'https:' ? { enable: true } : null;
            } else {
                this.dev = (request.dev === true) ? true : false;
                this.host = request.host ? request.host : '127.0.0.1';
                this.port = request.port ? request.port : '8765';
                this.ssl = request.ssl || null;
            }
        } else {
            this.dev = false;
        }
        if (/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(this.host) &&  this.host.indexOf('127.0.0.1') === -1) {
            console.warn("MCP.js notifications: Direct access to rpc service by ip will not be supported in the future (local access will not be affected). Please use the domain name to access the node (https://huygens.computecoin.network)");
        }
        // RPC server
        this.request = new HttpRequest({
            host: this.host,
            port: this.port,
            ssl: this.ssl
        });
        this.accounts = new Accounts(this.dev);
        this.version = version;
        this.utils = utils;
        this.abi = abi;
        this.Contract = Contract;
    }
}

// console.log(new Mcp());

module.exports = Mcp;

